import ENV from './Env.js';




export const getList = () => {

  return fetch(ENV.API_URL + '/promocode/all', {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    
  }).then((response) => {
    return response.json()
  });
}


export const makePromocode = (_api, _data) => {
  _data['api_token'] = _api;

  return fetch(ENV.API_URL + '/promocode/store', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(_data)
  }).then(function (response) {
    return response.json();
  });
}


export const updatePromocode = (_api, _data) => {
  _data['api_token'] = _api;

  return fetch(`${ENV.API_URL}/promocode/update/${_data['id']}`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(_data)
  }).then(function (response) {
    return response.json();
  });
}

